import React, { useEffect, useRef } from 'react'
import { useAuth } from './AuthContext'
import { useApi } from '../../Hooks/useApi'
import { usePreferences, sanitizePreferences } from './PreferencesContext'

// Pulls the signed-in user's preferences from the API once auth is available
// and pushes them into PreferencesContext (server wins over the localStorage
// cache). Renders nothing; saving is done by useUserPreferences.
const PreferencesSync: React.FC = () => {
  const { isLoggedIn } = useAuth()
  const { fetchApi } = useApi()
  const { setPreferences } = usePreferences()
  const hasSynced = useRef(false) // survives the StrictMode mount→unmount→remount cycle

  useEffect(() => {
    if (!isLoggedIn || hasSynced.current) return
    hasSynced.current = true

    fetchApi({ endpoint: '/api/preferences', method: 'GET' })
      .then((server) => {
        if (server) setPreferences(sanitizePreferences(server))
      })
      .catch((error) => {
        // Keep the cached/default preferences — a failed fetch must never block the app.
        console.debug('Preferences fetch failed; keeping cached preferences', error)
      })
  }, [isLoggedIn, fetchApi, setPreferences])

  return null
}

export default PreferencesSync
